// Copyright (C) 2021 Bystronic Laser AG

export default class Customer {
  constructor(public name: string, public no: string) {}
}
